import React from "react";
import styled from "styled-components";

import { formatUserName } from "@examspark/common";
import { colorFromTheme, RouterLink } from "@examspark/common-ui";
import { UserClassroom } from "@examspark/types";

const ClassroomListItems = styled.div``;
const ClassroomListItem = styled.div`
  display: flex;
  gap: 2rem;
  padding: 1rem 0.5rem;
  border-top: solid 1px #ddd;

  &:first-child {
    border-top: none;
    color: #333;
    font-size: 1.1rem;
    text-transform: uppercase;
  }
`;
const ClassroomListItemName = styled.div`
  width: 25rem;
`;
const ClassroomListItemOwner = styled.div`
  text-align: right;
  width: 20rem;
`;
const ClassroomListItemUnit = styled.div`
  /* text-align: right; */
  flex: 1;
`;
const ClassroomListItemProgress = styled.div`
  width: 10rem;
`;

const ClassProgressBar = styled.div`
  width: 100%;
  height: 1rem;
  display: flex;
  gap: 1px;
`;
const StyledProgressBarItem = styled.div<{ progress: number }>`
  flex-basis: 1px;
  flex-grow: ${(props) => props.progress};
  --radius: 0.5rem;

  &:first-child {
    background-color: ${colorFromTheme("primary")};
    border-radius: var(--radius) 0 0 var(--radius);
  }
  &:last-child {
    background-color: #e0e0e0;
    /* background-color: ${colorFromTheme("secondary")}; */
    border-radius: 0 var(--radius) var(--radius) 0;
  }
  // aka, only child
  &:first-child:last-child {
    border-radius: var(--radius);
  }
`;

export const ClassroomTableList = (props: {
  items: UserClassroom[] | undefined;
}) => {
  return (
    <ClassroomListItems>
      <ClassroomListItem>
        <ClassroomListItemName>Classroom Name</ClassroomListItemName>
        <ClassroomListItemUnit>Current Unit</ClassroomListItemUnit>
        <ClassroomListItemProgress>Progress</ClassroomListItemProgress>
        <ClassroomListItemOwner>Teacher</ClassroomListItemOwner>
      </ClassroomListItem>
      {props.items?.map((c) => {
        const user = c.classroom?.users?.[0];
        const unitInProgress = c.classroom?.units?.find(
          (u) => u?.maturity === "IN_PROGRESS",
        );

        // filter out deleted/invalid classrooms
        if (!c.classroom) return null;

        const unitIndex = c.classroom?.course?.unitIds?.findIndex(
          (cu) => cu.id === c.classroom?.unitId,
        );
        const unitCount = c.classroom?.course?.unitIds?.length ?? 0;

        return (
          <ClassroomListItem key={c.id}>
            <ClassroomListItemName>
              <RouterLink to={`/classroom/${c.classroom?.id}`}>
                {c.classroom?.name || "(Untitled Classroom)"}
              </RouterLink>
            </ClassroomListItemName>
            <ClassroomListItemUnit>
              <RouterLink
                to={`/classroom/${c.classroom?.id}/unit/${unitInProgress?.unit?.id}`}
              >
                {unitInProgress?.unit?.name}
              </RouterLink>
            </ClassroomListItemUnit>
            <ClassroomListItemProgress>
              <ClassProgressBar>
                {unitIndex === -1 ? null : (
                  <StyledProgressBarItem progress={(unitIndex ?? -1) + 1} />
                )}
                <StyledProgressBarItem progress={unitCount ?? 1} />
              </ClassProgressBar>
            </ClassroomListItemProgress>
            <ClassroomListItemOwner>
              <RouterLink to={`/user/${c.workspaceId}/${user?.user?.id}`}>
                {formatUserName(user?.user)}
              </RouterLink>
            </ClassroomListItemOwner>
          </ClassroomListItem>
        );
      })}
    </ClassroomListItems>
  );
};
